import {
	IGetModifierGroupsShort,
	ICreateModifierGroups,
	ICreateModifierGroupsV2,
	IUpdateModifierGroups,
	IUpdateModifierGroupsV2,
	IGetPaginatedModifierGroups,
	IGetPaginatedModifierGroupsV2,
	IGetModifierGroupsTemplateInfoArgs,
	IUpdateModifierGroupsTemplateInfo,
	IGetModifierGroupsByProductIdAndRestaurantIdArguments,
	IGetModGroupRestaurantPropertiesArguments,
	IGetModifiersForAssignArguments,
	IUpdateModGroupRestaurantProperties,
	IUpdateRestaurantPropertiesAsPatchForModGroup,
	IUpdateModGroupProductsInclusive,
} from 'types';
import {
	serviceGetModifierGroupsInfo,
	serviceGetModifierGroupInfoV2,
	serviceGetModifierGroupsShort,
	serviceGetModifierGroupPaginatedInfo,
	serviceCreateModifierGroups,
	serviceCreateModifierGroupsV2,
	serviceUpdateModifierGroups,
	serviceUpdateModifierGroupsV2,
	serviceGetPaginatedModifierGroups,
	serviceGetPaginatedModifierGroupsV2,
	serviceDeleteModifierGroups,
	serviceDeleteModifierGroupsV2,
	serviceGetModifierGroupsTemplateInfo,
	serviceUpdateModifierGroupsTemplateInfo,
	serviceGetModifierGroupsByProductIdAndRestaurantId,
	serviceGetAllModifierGroupsFromCustomerByProductIdAndRestaurantId,
	serviceGetModifierGroupsShortByCustomerId,
	serviceGetModifierGroupsShortByRestaurantId,
	serviceGetModGroupRestaurantProperties,
	serviceUpdateRestaurantsInModGroup,
	serviceGetModifierTemplates,
	serviceGetAvailableModifiers,
	serviceUpdateModifierTemplates,
	serviceGetModifiersForAssign,
	serviceUpdateModGroupRestaurantProperties,
	serviceUpdateModGroupRestaurantPropertiesAsPatch,
	serviceUpdateModGroupProductsInclusive,
} from 'services/api/modifierGroups';
import { createAppErrorMessage } from 'utils/helpers';

// Menu v1
const getModifierGroupsInfo = async (modifierGroupID: string) => {
	try {
		const response = await serviceGetModifierGroupsInfo(modifierGroupID);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v1
// Menu v2
const getModifierGroupInfoV2 = async (modifierGroupID: string) => {
	try {
		const response = await serviceGetModifierGroupInfoV2(modifierGroupID);
		return response.data;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v2

const getModifierGroupsShortInfo = async (args: IGetModifierGroupsShort) => {
	try {
		const response = await serviceGetModifierGroupsShort(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};

const getModifierGroupPaginatedInfo = async (modifierGroupID: string) => {
	try {
		const response = await serviceGetModifierGroupPaginatedInfo(modifierGroupID);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

// Menu v1
const createModifierGroups = async (data: ICreateModifierGroups) => {
	try {
		await serviceCreateModifierGroups(data);
	} catch (err) {
		throw err;
	}
};
// Menu v1
// Menu v2
const createModifierGroupsV2 = async (data: ICreateModifierGroupsV2) => {
	try {
		const response = await serviceCreateModifierGroupsV2(data);
		return response;
	} catch (err) {
		throw err;
	}
};
// Menu v2

// Menu v1
const updateModifierGroups = async (data: IUpdateModifierGroups) => {
	try {
		await serviceUpdateModifierGroups(data);
	} catch (err) {
		throw err;
	}
};
// Menu v1
// Menu v2
const updateModifierGroupsV2 = async (data: IUpdateModifierGroupsV2) => {
	try {
		const response = await serviceUpdateModifierGroupsV2(data);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingModifierGroup');
		throw new Error(errorMessage);
	}
};
// Menu v2

// Menu v1
const getPaginatedModifierGroups = async (args: IGetPaginatedModifierGroups) => {
	try {
		const response = await serviceGetPaginatedModifierGroups(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v1
// Menu v2
const getPaginatedModifierGroupsV2 = async (args: IGetPaginatedModifierGroupsV2) => {
	try {
		const response = await serviceGetPaginatedModifierGroupsV2(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};
// Menu v2

// Menu v1
const deleteModifierGroups = async (modifierGroupID: string) => {
	try {
		await serviceDeleteModifierGroups(modifierGroupID);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorDeletingModifierGroup');
		throw new Error(errorMessage);
	}
};
// Menu v1

// Menu v2
const deleteModifierGroupsV2 = async (modifierGroupID: string) => {
	try {
		await serviceDeleteModifierGroupsV2(modifierGroupID);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorDeletingModifierGroup');
		throw new Error(errorMessage);
	}
};
// Menu v2

const getModifierGroupsTemplateInfo = async (args: IGetModifierGroupsTemplateInfoArgs) => {
	try {
		const response = await serviceGetModifierGroupsTemplateInfo(args);
		return response;
	} catch (err) {
		throw err;
	}
};

const updateModifierGroupsTemplateInfo = async (data: IUpdateModifierGroupsTemplateInfo) => {
	try {
		await serviceUpdateModifierGroupsTemplateInfo(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingModifierGroup');
		throw new Error(errorMessage);
	}
};

const getGetModifierGroupsByProductIdAndRestaurantId = async (
	args: IGetModifierGroupsByProductIdAndRestaurantIdArguments,
) => {
	try {
		const response = await serviceGetModifierGroupsByProductIdAndRestaurantId(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const getAllModifierGroupsFromCustomerByProductIdAndRestaurantId = async (
	args: IGetModifierGroupsByProductIdAndRestaurantIdArguments,
) => {
	try {
		const response = await serviceGetAllModifierGroupsFromCustomerByProductIdAndRestaurantId(args);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const getModifierGroupsShortByCustomerId = async (customerId: string) => {
	try {
		const response = await serviceGetModifierGroupsShortByCustomerId(customerId);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};

const getModifierGroupsShortByRestaurantId = async (restaurantId: string) => {
	try {
		const response = await serviceGetModifierGroupsShortByRestaurantId(restaurantId);
		return response;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataInListsNotPulled');
		throw new Error(errorMessage);
	}
};

const getModGroupRestaurantProperties = async (args: IGetModGroupRestaurantPropertiesArguments) => {
	try {
		const response = await serviceGetModGroupRestaurantProperties(args);
		return response.data;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const updateRestaurantsInModGroup = async (data: { modifierGroupId: string; restaurantIds: string[] }) => {
	try {
		await serviceUpdateRestaurantsInModGroup(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingModifierGroup');
		throw new Error(errorMessage);
	}
};

const getModifierTemplates = async (modifierGroupId: string) => {
	try {
		const response = await serviceGetModifierTemplates(modifierGroupId);
		return response;
	} catch (err) {
		throw err;
	}
};

const getAvailableModifiers = async (customerId: string) => {
	try {
		const response = await serviceGetAvailableModifiers(customerId);
		return response.data;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const updateModifierTemplates = async (data: { modifierGroupId: string; modifierIds: string[] }) => {
	try {
		await serviceUpdateModifierTemplates(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingModifierTemplates');
		throw new Error(errorMessage);
	}
};

const getModifiersForAssign = async (args: IGetModifiersForAssignArguments) => {
	try {
		const response = await serviceGetModifiersForAssign(args);
		return response.data;
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'dataNotPulled');
		throw new Error(errorMessage);
	}
};

const updateModGroupRestaurantProperties = async (data: IUpdateModGroupRestaurantProperties) => {
	try {
		await serviceUpdateModGroupRestaurantProperties(data);
	} catch (err) {
		throw err;
	}
};

const updateModGroupRestaurantPropertiesAsPatch = async (data: IUpdateRestaurantPropertiesAsPatchForModGroup) => {
	try {
		await serviceUpdateModGroupRestaurantPropertiesAsPatch(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingModifierGroup');
		throw new Error(errorMessage);
	}
};

const updateModGroupProductsInclusive = async (data: IUpdateModGroupProductsInclusive) => {
	try {
		await serviceUpdateModGroupProductsInclusive(data);
	} catch (err) {
		const errorMessage = createAppErrorMessage(err, 'errorUpdatingInclusive');
		throw new Error(errorMessage);
	}
};

export {
	getModifierGroupsInfo,
	getModifierGroupInfoV2,
	getModifierGroupsShortInfo,
	getModifierGroupPaginatedInfo,
	createModifierGroups,
	createModifierGroupsV2,
	updateModifierGroups,
	updateModifierGroupsV2,
	getPaginatedModifierGroups,
	getPaginatedModifierGroupsV2,
	deleteModifierGroups,
	deleteModifierGroupsV2,
	getModifierGroupsTemplateInfo,
	updateModifierGroupsTemplateInfo,
	getGetModifierGroupsByProductIdAndRestaurantId,
	getAllModifierGroupsFromCustomerByProductIdAndRestaurantId,
	getModifierGroupsShortByCustomerId,
	getModifierGroupsShortByRestaurantId,
	getModGroupRestaurantProperties,
	updateRestaurantsInModGroup,
	getModifierTemplates,
	getAvailableModifiers,
	updateModifierTemplates,
	getModifiersForAssign,
	updateModGroupRestaurantProperties,
	updateModGroupRestaurantPropertiesAsPatch,
	updateModGroupProductsInclusive,
};
